import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type Props = {
  label: string;
  sub?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CTAButton({
  label,
  sub,
  size = 'lg',
  className = ''
}: Props) {
  return <div className={`w-full ${className}`} data-id="element-25" data-mp="2fzl9bbhoa6wc">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-xl bg-gold-500 text-center font-display font-extrabold uppercase tracking-wide text-ink-950 shadow-[0_8px_0_0_#A96B02] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-gold-400 active:translate-y-[3px] active:shadow-[0_5px_0_0_#A96B02] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-400/60 ${size === 'lg' ? 'px-5 py-4 text-xl leading-tight sm:text-2xl' : 'px-4 py-3.5 text-lg leading-tight sm:text-xl'}`} data-id="element-26" data-mp="2fysb4yws4ppt">
        <span data-id="element-27" data-mp="38q3i8t52v2ho">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-28" data-mp="198wl1ahllk54" />
      </a>
      {sub ? <p className="mt-2.5 text-center text-[11px] font-semibold uppercase tracking-wider text-steel-500 sm:text-xs" data-id="element-29" data-mp="1i9kxi0rcfcfw">
          {sub}
        </p> : null}
    </div>;
}